var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseLivePlayer from '../base/base-live-player';
import { KERNEL_NAME } from '../enums';
import { mergeKernelConfig } from './default-config';
/**
 * 使用原生内核的简易直播播放器
 */
var LivePlayer = /** @class */ (function (_super) {
    __extends(LivePlayer, _super);
    function LivePlayer(conf) {
        return _super.call(this, mergeKernelConfig(conf)) || this;
    }
    Object.defineProperty(LivePlayer.prototype, "kernelName", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return KERNEL_NAME.ORIGIN;
        },
        enumerable: false,
        configurable: true
    });
    return LivePlayer;
}(BaseLivePlayer));
export default LivePlayer;
;
